export default (params) => ({
  trigger: {
    name: 'mini_cart_in_checkout.select_charger_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
